import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSavedDeliverySettings,
  fetchInvoiceRecipient,
  createInvoiceRecipient,
  updateInvoiceRecipient,
  getAuthenticatedUser,
  logoutAdmin,
  logoutUser,
} from '~/api';

const initialState = {
  id: null,
  userId: null,
  name: '',
  email: '',
  personInCharge: '',
  department: '',
  zip: '',
  pref: '',
  address: '',
};

/**
 * 請求書データ管理用Slice。
 */
const invoiceRecipientSlice = createSlice({
  name: 'invoiceRecipient',
  initialState,
  reducers: {
    initialize: () => initialState,
    change: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchSavedDeliverySettings.fulfilled.type]: (state, action) => {
      // APIレスポンスの請求書データがnullだったら、初期値としてuserのデータを詰める
      if (action.payload.invoiceRecipients === null) {
        return {
          ...state,
          userId: action.payload.userId,
          name: action.payload.users.companyName,
          email: action.payload.users.email,
          personInCharge: action.payload.users.name,
          department: action.payload.users.departmentName,
          zip: action.payload.users.zip,
          pref: action.payload.users.pref,
          address: action.payload.users.address,
        };
      }
      return {
        ...state,
        ...action.payload.invoiceRecipients,
      };
    },

    // ログインユーザー取得APIが呼ばれた時
    [getAuthenticatedUser.fulfilled.type]: (state, action) => {
      // まだ請求書データがセットされていない時は、初期値としてuserのデータを詰める
      if (state.userId === null) {
        return {
          ...state,
          userId: action.payload.result.id,
          name: action.payload.result.companyName,
          email: action.payload.result.email,
          personInCharge: action.payload.result.name,
          department: action.payload.result.departmentName,
          zip: action.payload.result.zip,
          pref: action.payload.result.pref,
          address: action.payload.result.address,
        };
      }
      // それ以外の場合はそのまま
      return state;
    },

    // 請求書データ取得APIが呼ばれた時
    [fetchInvoiceRecipient.fulfilled.type]: (state, action) => {
      // まだDBに請求書データができていない時は、stateを更新しない。
      if (action.payload === null) {
        return state;
      }
      return action.payload;
    },

    [createInvoiceRecipient.fulfilled.type]: (_, action) => {
      return action.payload;
    },

    [updateInvoiceRecipient.fulfilled.type]: (_, action) => {
      return action.payload;
    },
    [logoutAdmin.fulfilled.type]: () => {
      return initialState;
    },

    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },
  },
});

export const { initialize } = invoiceRecipientSlice.actions;

// reducerをexportする
export default invoiceRecipientSlice.reducer;
